"use client";

import { createContext } from "react";

export interface FieldContextType {
  controlId?: string;
  messages?: any[];
  control?: {
    type?: string;
    control?: any;
    renderControl?: (props: any) => React.ReactNode;
    isToggle?: boolean;
    [key: string]: any;
  };
  hint?: React.ReactNode;
  label?: React.ReactNode;
  labelAfter?: React.ReactNode;
  tooltip?: React.ReactNode;
  isRadioCheck?: boolean;
}

const FieldContext = createContext<FieldContextType | null>(null);

export { FieldContext };
